import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import download from "../../../Assets/download1.svg";
import upload from "../../../Assets/upload.svg";
import plus from "../../../Assets/plus.svg";
import ReportBackground from "../../../Assets/report.svg";
import run from "../../../Assets/run.svg";
import MailLogo from "../../../Assets/mail.svg";
import PrintLogo from "../../../Assets/print.svg";
import DownloadLogo from "../../../Assets/down.svg";
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import BackLogo from "../../../Assets/back.svg";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import logo from "../../../Assets/rotating-logo.png";
import EyeIcon from "../../../Assets/new-eye.svg";
import DeleteIcon from "../../../Assets/new-delete.svg";
import PencilIcon from "../../../Assets/pencil.svg";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import classes from "./PrintCashbook.module.css";
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";


const PrntCashbook = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]); // regions for continent_id=23
  const [load, setLoad] = useState(false);
  const [tableData4, setTableData4] = useState([]); // provinces for selected region
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]); // all provinces fallback
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]); // account options (fetched by province)
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  // const [searchTerm, setSearchTerm] = useState("");
  // const [loading, setLoading] = useState(false);
  // const [load, setLoad] = useState(false);
  // const [accounts, setAccounts] = useState([]);
  // const [inputss, setInputss] = useState([]);
  // const [tableData45, setTableData45] = useState([]);
  const [GenLedger, setGenLedger] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  // const [savingsLoading, setSavingsLoading] = useState(false);
  const [generalLoading, setGeneralLoading] = useState(false);
  // const [fetchingLoading, setFetchingLoading] = useState(false);
  // const [totalDebit, setTotalDebit] = useState('');
  // const [totalCredit, setTotalCredit] = useState('');
  // const [bearer, setBearer] = useState('');
  // const navigate = useNavigate();
  const [paidBooking, setPaidBooking] = useState([]);
  const [savingss, setSavingss] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState([]);
  // const [user, setUser] = useState("");
  // const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedCustomerName, setSelectedCustomerName] = useState([]);
  const [selectedSavingsType, setSelectedSavingsType] = useState([]);
  const [selectedSavingsName, setSelectedSavingsName] = useState('');
  // const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData3, setTableData3] = useState([]);
  // const [tableData4, setTableData4] = useState([]);
  const [filteredDatas, setFilteredDatas] = useState([]);
  // const [selectedRegion, setSelectedRegion] = useState('');
  // const [admin, setAdmin] = useState('');
  // const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedAccount, setSelectedAccount] = useState('');
  // const [tableData, setTableData] = useState([]);
  // const [selectedEndDate, setSelectedEndDate] = useState('');
  // const [selectedDate, setSelectedDate] = useState('');
  // const [entriesPerPage, setEntriesPerPage] = useState(100);
  // const [currentPage, setCurrentPage] = useState(1);
  const [userType, setUserType] = useState('');
  const [consolidatedLoading, setConsolidatedLoading] = useState(false);
  // const [continent, setContinent] = useState('');
  // const [region, setRegion] = useState('');
  // const [province, setProvince] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
            const value4 = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (value4 !== null) {
        setAdmin(value4);
      }
      if (admins !== null) {
        setUserType(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };







  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      // setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      // setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  const fetchAccounts = async () => {
    setAccounts([]);
    setSavingsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/reports/general-ledger-filter`, {
        params: {
          gl_code: selectedBank?.value || "",
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || "",
          region_id: selectedRegion || "",
          province_id: selectedProvince || ""
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
const resultsss = response.data?.data?.journal;
      setAccounts(resultsss);

      const resultssx = response.data?.data?.input;
      setInputss(resultssx);

      console.log(resultsss);
      if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
        setAccounts([]);   // ✅ clear previous data
        setNoData(true);
        return;
      }

      // const resultsss = response.data?.data?.journal;
      // const resultssx = response.data?.data?.input;

      setAccounts(resultsss);
      setInputss(resultssx);
      setNoData(false);

      console.log(resultsss);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.log(error);
        setAccounts([]);   // ✅ also clear here on error
        setNoData(true);
      }
    } finally {
      setSavingsLoading(false);
    }
  };





  const filteredAccounts = accounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.details?.toLowerCase().includes(term) ||
      item.cheque_number?.toLowerCase().includes(term) ||
      item.transaction_date?.toLowerCase().includes(term)
    );
  });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash-and-bank`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      // setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);





  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  // const handlePrevPage = () => {
  //   setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  // };

  // const handleNextPage = () => {
  //   setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  // };

  // const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  // Replace: fetchContinents now calls /v1/continents to get list of continents
  // const fetchContinents = async () => {
  //   setIsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/continents`, { headers });
  //     const results = Array.isArray(response.data?.data) ? response.data.data : [];
  //     const options = results.map((item) => ({
  //       label: item.description || item.name || `Continent ${item.id}`,
  //       value: item.id,
  //     }));
  //     setSelectOptions(options); // continents
  //   } catch (error) {
  //     console.log(error);
  //     setSelectOptions([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // New: fetch regions for a selected continent
  // const fetchRegions = async (continentId) => {
  //   if (!continentId) {
  //     setTableData4([]); // clear regions
  //     return;
  //   }
  //   setLoad(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/v1/continents/getcontinentregions?continent_id=${continentId}`, { headers });
  //     const results = Array.isArray(response.data?.data) ? response.data.data : [];
  //     const options = results.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setTableData4(options); // regions for selected continent
  //   } catch (error) {
  //     console.log(error);
  //     setTableData4([]);
  //   } finally {
  //     setLoad(false);
  //   }
  // };

  // Modified: fetchSubRegion now fetches provinces for a region and fills tableData45 (provinces)
  // const fetchSubRegion = async (regionId) => {
  //   if (!regionId) {
  //     setTableData45([]);
  //     return;
  //   }
  //   setLoad(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/v1/regions/getprovincesregion?region_id=${regionId}`, { headers });
  //     const subCont1 = Array.isArray(response.data?.data) ? response.data.data : [];
  //     const options2 = subCont1.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
      // setTableData45(options2);
      // populate Province select
  //   } catch (error) {
  //     console.log(error);
  //     setTableData45([]);
  //   } finally {
  //     setLoad(false);
  //   }
  // };



  // handlers wiring the cascade (updated)
  // const handleContinentChange = (selectedOption) => {
  //   const continentId = selectedOption?.value;
  //   setSelectedContinent(continentId);
    // clear downstream
  //   setSelectedRegion('');
  //   setSelectedProvince('');
  //   setTableData4([]);   // regions
  //   setTableData45([]);  // provinces
  //   setAllAccounts([]);
  //   if (continentId) fetchRegions(continentId);
  // };

  // const handleRegionChange = (selectedOption) => {
  //   const regionId = selectedOption?.value;
  //   setSelectedRegion(regionId);
  //   // clear downstream
  //   setSelectedProvince('');
  //   setTableData45([]); // provinces
  //   setAllAccounts([]);
  //   if (regionId) fetchSubRegion(regionId); // fetch provinces for region
  // };


  // ✅ Fetch provinces when a region is selected
// const fetchProvince = async (regionId) => {
//   try {
//     const response = await axios.get(`${BASE_URL}/v1/provinces/get-province-account?province_id=${regionId}`);
//     setProvinceOptions(response.data || []);
//   } catch (error) {
//     console.error('Error fetching provinces:', error);
//   }
// };

//  const fetchProvince = async () => {
//     setLoad(true);
//     try {
//       const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
  //     const subCont15 = response.data?.data.provinces;
  //     const options25 = subCont15.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setTableData45(options25);
  //     console.log(response);
  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       // Redirect to login page if unauthorized
  //       navigate('/login');
  //     } else {
  //       let errorMessage = 'An error occurred. Please try again.';
  //       if (error.response && error.response.data && error.response.data.message) {
  //         if (typeof error.response.data.message === 'string') {
  //           errorMessage = error.response.data.message;
  //         } else if (Array.isArray(error.response.data.message)) {
  //           errorMessage = error.response.data.message.join('; ');
  //         } else if (typeof error.response.data.message === 'object') {
  //           errorMessage = JSON.stringify(error.response.data.message);
  //         }
  //       }
  //       setTableData3([]);
  //     }
  //   } finally {
  //     setLoad(false);
  //   }
  // };

  // useEffect(() => {
  //   if (bearer && selectedContinent) {
  //     fetchSubContinents(selectedContinent);
  //   }
  // }, [bearer, selectedContinent]);

  // useEffect(() => {
  //   if (bearer && selectedRegion) {
  //     fetchSubRegion(selectedRegion);
  //   }
  // }, [bearer, selectedRegion]);

  // useEffect(() => {
  //   if (bearer) {
  //     fetchProvince();
  //   }
  // }, [bearer]);


// ✅ Fetch accounts when a province is selected
// const fetchProvinceAccounts = async (provinceId) => {
//   try {
//     const response = await axios.get(`${BASE_URL}/provinces/get-province-account?province_id=${provinceId}`);
//     setAccountOptions(response.data || []);
//   } catch (error) {
//     console.error('Error fetching province accounts:', error);
//   }
// };


//   const handleProvinceChange = (selectedOption) => {
//     const provId = selectedOption?.value;
//     setSelectedProvince(provId);
//     setAllAccounts([]);
//     if (provId) fetchProvinceAccounts(provId);
//   };

//   useEffect(() => {
//     if (bearer) fetchContinents();
//   }, [bearer]);

//   useEffect(() => {
//     if (bearer) fetchProvince(); 
//     }, [bearer]);

  const handlePrint = () => {
    window.print();
  };


const exportToExcel = async () => {
  if (!accounts || accounts.length === 0) {
    console.log("No data available to export");
    return;
  }



  // Format number for consistency
    const formatNumber = (num) =>
      parseFloat(num || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  
    // Format date helper
    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "--";
  
    // Get heading info from inputss
    const name = inputss?.name || "Cashbook Report";
    const startDate = formatDate(inputss?.start_date);
    const endDate = formatDate(inputss?.end_date);
  
    // Create Excel rows
    const excelRows = [];
  
    // ====== HEADER SECTION ======
    excelRows.push([name]); // First line: Name
    excelRows.push([
      `Cashbook Report between the period of ${startDate} to ${endDate}`,
    ]); // Second line: Date range
    excelRows.push([]);

  // Opening Balance section
  excelRows.push(["Opening Balance", "", "", "", "", formatNumber(accounts[0]?.opening_balance)]);
  excelRows.push([]); // Empty row for spacing

  // Header row
  excelRows.push([
    "POST DATE",
    "VALUE DATE",
    "DETAILS",
    "",
    "DEBIT",
    "CREDIT",
  ]);

  // Transaction rows
  accounts.forEach((item) => {
    const debit = parseFloat(item.debit) || 0;
    const credit = parseFloat(item.credit) || 0;

    excelRows.push([
      item.created_at ? new Date(item.created_at).toLocaleDateString() : "",
      item.transaction_date || "",
      item.details || "",
      "",
      debit > 0 ? formatNumber(debit) : "--",
      credit > 0 ? formatNumber(credit) : "--",
    ]);
  });

  // Totals row
  const totalDebit = accounts.reduce((sum, item) => sum + (parseFloat(item.debit) || 0), 0);
  const totalCredit = accounts.reduce((sum, item) => sum + (parseFloat(item.credit) || 0), 0);

  excelRows.push([]);
  excelRows.push([
    "TOTALS",
    "",
    "",
    "",
    formatNumber(totalDebit),
    formatNumber(totalCredit),
  ]);

  // Closing Balance row
  excelRows.push([
    "CLOSING BALANCE",
    "",
    "",
    "",
    "",
    formatNumber(accounts[0]?.closing_balance),
  ]);

  // Create worksheet from array
  const worksheet = XLSX.utils.aoa_to_sheet(excelRows);

  // Adjust column widths for better readability
  worksheet["!cols"] = [
    { wch: 15 }, // POST DATE
    { wch: 15 }, // VALUE DATE
    { wch: 40 }, // DETAILS
    { wch: 10 }, // (empty)
    { wch: 15 }, // DEBIT
    { wch: 15 }, // CREDIT
  ];

  // Create and append workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Cash Book Report");

  // Export the Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "CashBookReport.xlsx");
};

const exportToPDF = () => {
  const dataToExport = accounts;
  const dataToExport2 = inputss;

  if (!dataToExport || dataToExport.length === 0) {
    console.log("No data available to export");
    return;
  }

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  // 🟦 HEADER SECTION
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.text(dataToExport2.name || "", pageWidth / 2, 22, { align: "center" });

  const startDate = dataToExport2?.start_date
    ? new Date(dataToExport2.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--";

  const endDate = dataToExport2?.end_date
    ? new Date(dataToExport2.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--";

  doc.setFontSize(11);
  doc.text(
    `Cashbook Report between ${startDate} and ${endDate}`,
    pageWidth / 2,
    29,
    { align: "center" }
  );

  // 🟨 OPENING BALANCE ROW
  const openingBalance = parseFloat(dataToExport?.[0]?.opening_balance || 0).toLocaleString(
    "en-US",
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  );

  doc.setFontSize(12);
  doc.setTextColor(59, 130, 246); // blue
  doc.text(`Opening Balance: ${openingBalance}`, 14, 38);

  // 🧾 TABLE HEADERS
  const columns = [
    { header: "POST DATE", dataKey: "post_date" },
    { header: "VALUE DATE", dataKey: "value_date" },
    { header: "DETAILS", dataKey: "details" },
    { header: "", dataKey: "empty" },
    { header: "DEBIT", dataKey: "debit" },
    { header: "CREDIT", dataKey: "credit" },
  ];

  // 🧮 TABLE ROWS
  const rows = dataToExport.map((item) => {
    const debit = parseFloat(item.debit) || 0;
    const credit = parseFloat(item.credit) || 0;
    return {
      post_date: item.created_at
        ? new Date(item.created_at).toLocaleDateString("en-GB")
        : "",
      value_date: item.transaction_date || "",
      details: item.details || "",
      empty: "",
      debit:
        debit > 0
          ? debit.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : "--",
      credit:
        credit > 0
          ? credit.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : "--",
    };
  });

  // 🧾 TOTALS ROW
  const totalDebit = dataToExport.reduce(
    (sum, item) => sum + (parseFloat(item.debit) || 0),
    0
  );
  const totalCredit = dataToExport.reduce(
    (sum, item) => sum + (parseFloat(item.credit) || 0),
    0
  );

  rows.push({
    post_date: "TOTALS",
    value_date: "",
    details: "",
    empty: "",
    debit: totalDebit.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    credit: totalCredit.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
  });

  // 🟩 TABLE RENDER
  doc.autoTable({
    columns,
    body: rows,
    startY: 45,
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [0, 51, 102], textColor: 255, fontSize: 9 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    columnStyles: {
      details: { cellWidth: 60 },
      debit: { halign: "right" },
      credit: { halign: "right" },
    },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageSize = doc.internal.pageSize;
      const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

      // Footer
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, pageHeight - 10);
      doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
    },
  });

  // 🟩 CLOSING BALANCE
  const closingBalance = parseFloat(dataToExport?.[0]?.closing_balance || 0).toLocaleString(
    "en-US",
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  );

  const y = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text("Closing Balance:", 14, y);
  doc.setTextColor(22, 163, 74); // green
  doc.text(closingBalance, pageWidth - 30, y, { align: "right" });

  doc.save("CashbookReport.pdf");
};  
  
const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/province-cash-and-bank?province_id=${selectedProvince}`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));

      setAllAccounts(opt1);
      console.log(response);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setAllAccounts([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer && selectedProvince) {
      fetchCharts(selectedProvince);

    }
  }, [bearer, selectedProvince]);



  const filteredData = accounts.filter(item => item.details.toLowerCase().includes(searchTerm.toLowerCase()));

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  // const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };



  const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
  const displayedData = filteredData.slice(startIndexx - 1, endIndexx);



  const fetchConsolidated = async () => {
    setConsolidatedLoading(true);

    try {

      const response = await axios.get(
        `${BASE_URL}/reports/get-consolidated-reports`, {
        params: {
          gl_code: selectedAccount,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || "",
          region_id: selectedRegion || "",
          province_id: selectedProvince || ""

        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
      const filtData1 = response.data?.data?.input || [];
      const filtData2 = response.data?.data?.journal || [];

      if (filtData2.length === 0) {
        // toast.error('No data found for the selected account.');
      } else {
        // setInputss(filtData1);
        setAccounts(filtData1);
        navigate('/accounting/print_cashbook_new_consolidated', { state: { document: filtData2, inputs: filtData1 } });

      }
      console.log(response, "consolidated");
      // const genLed = response.data?.data;
      // setGenLedger(genLed);
      //     const genTotal = response.data?.data?.total;
      // setTotalEntries(genTotal);
      // const genLast = response.data?.data?.last_page || 1;
      // setTotalPages(genLast);

      // console.log(genLed, "NI");
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setConsolidatedLoading(false);
    }
  };


  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent}`, { headers });

      // console.log(response);
      const subCont = response.data?.data;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [bearer, selectedContinent]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
    setTableData([]);
    setSelectedAccount(null);
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (accounts) {
      const debitTotal = accounts.reduce((total, item) => total + parseFloat(item.debit), 0);
      const creditTotal = accounts.reduce((total, item) => total + parseFloat(item.credit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}  onClick={() => navigate(-1)}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Cashbook Report</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                <Select
                  onChange={handleContinentChange}        // was handleBank
                  options={selectOptions}                 // now populated from getcontinentregions?continent_id=23
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Region:</label>
                <Select
                  onChange={(selectedOption) => handleRegionChange(selectedOption)}          // calls fetchSubRegion -> populates provinces (tableData4)
                  options={tableData3}                   // provinces for selected region
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Province:</label>
                <Select
                  onChange={(selectedOption) => {
                    handleProvinceChange(selectedOption);
                    // when a province is selected we want accounts (use fetchProvinceAccounts)
                    // fetchProvinceAccounts(opt?.value);
                  }}
                  options={tableData4} // if you already populate tableData45 elsewhere, keep; otherwise you may want to set this to tableData4 depending on desired cascading
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Account:</label>
                <Select
                  onChange={handleBank}
                  options={allAccounts} // populated by fetchProvinceAccounts
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{ fontSize: 14 }}
                  // min={minDate}
                  // max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  // min={minDate}
                  style={{ fontSize: 14 }}
                  // max={maxDate}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}

          </div>


        </div>
        <div style={{ marginTop: 24 }} />

      <div className={classes.tableContainer}>
  {accounts.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        fontSize: "18px",
        color: "#374151",
      }}
    >
      <p>No data to display</p>
    </div>
  ) : (
    <>
      <div className={classes.sideTools}>
        {accounts.length > 0 && (
          <div className={classes.filterIcons}>
            <img
              src={MailLogo}
              alt="icon1"
              className={classes.iconBtns}
              onClick={() => console.log("icon1")}
            />
            <img
              onClick={() => handlePrint()}
              src={PrintLogo}
              alt="icon2"
              className={classes.iconBtns}
            />
            {/* <img
              src={DownloadLogo}
              alt="icon3"
              className={classes.iconBtns}
              onClick={() => console.log("icon3")}
            /> */}
            <img
              onClick={() => exportToExcel()}
              src={ExcelLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
            <img
              onClick={() => exportToPDF()}
              src={PdfLogo}
              alt="icon3"
              className={classes.iconBtns}
            />
          </div>
        )}
      </div>

      <div className={classes.cntrTable}>
        <h1 className={classes.cntrTxt}>
          The Redeemed Christian Church Of God
        </h1>
        <p className={classes.cntrTxt12}>{inputss?.name}</p>
        <p className={classes.cntrTx122}>Cashbook Report
          between the period of {" "} {inputss?.start_date
            ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "--"} to {" "}
          {inputss?.end_date
            ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "--"}
        </p>
        <p className={classes.cntrTx122}>
          Account: {" "}{selectedBank?.label}
        </p>
      </div>

      {/* ✅ Insert the table here */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
        <thead>
          <tr style={{borderBottom: "1px solid #d1d5db",}}>
            <th
              colSpan={5}
              style={{
                textAlign: "left",
                color: "#3B82F6",
                fontWeight: 700,
                fontSize: 18,
                padding: "8px",
                
              }}
            >
              Opening Balance
            </th>
            <th
              style={{
                textAlign: "right",
                color: "#3B82F6",
                fontWeight: 700,
                fontSize: 18,
                padding: "8px",
              }}
            >
              {parseFloat(accounts[0]?.opening_balance || 0).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </th>
          </tr>
          <tr style={{borderBottom: "1px solid #d1d5db",}}>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>POST DATE</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>VALUE DATE</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>DETAILS</th>
            <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}></th>
            <th style={{ padding: "8px", textAlign: "right", fontSize: 12 }}>DEBIT</th>
            <th style={{ padding: "8px", textAlign: "right", fontSize: 12 }}>CREDIT</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((item, index) => {
            const debit = parseFloat(item.debit) || 0;
            const credit = parseFloat(item.credit) || 0;

            return (
              <tr key={index} style={{borderBottom: "1px solid #d1d5db",}}>
                <td style={{ padding: "8px", fontSize: 12, whiteSpace: 'nowrap' }}>
                  {formatDates(item.created_at)}
                </td>
                <td style={{ padding: "8px", fontSize: 12,  whiteSpace: 'nowrap' }}>{item.transaction_date}</td>
                <td
                  style={{
                    padding: "8px",
                    maxWidth: "400px",
                    whiteSpace: "normal",
                    fontSize: 12
                  }}
                >
                  {item.details}
                </td>
                <td></td>
                <td
                  style={{
                    padding: "8px",
                    textAlign: "right",
                    color: debit > 0 ? "red" : "#111827",
                    fontSize: 12
                  }}
                >
                  {debit > 0
                    ? debit.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "--"}
                </td>
                <td
                  style={{
                    padding: "8px",
                    textAlign: "right",
                    fontSize: 12,
                    color: credit > 0 ? "green" : "#111827",
                  }}
                >
                  {credit > 0
                    ? credit.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "--"}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr >
            <td style={{ padding: "8px", fontWeight: 700, fontSize: 14 }}>TOTALS</td>
            <td></td>
            <td></td>
            <td></td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "red",
                fontWeight: 700,
                fontSize: 14
              }}
            >
              {accounts
                .reduce(
                  (sum, item) => sum + (parseFloat(item.debit) || 0),
                  0
                )
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "green",
                fontWeight: 700,
                fontSize: 14
              }}
            >
              {accounts
                .reduce(
                  (sum, item) => sum + (parseFloat(item.credit) || 0),
                  0
                )
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </td>
          </tr>
          <tr style={{ background: `linear-gradient(#CFD9EB66, #CFD9EB)`,}}>
            <td style={{ fontSize: 14, color: 'black', fontWeight: 700, padding: 5 , whiteSpace: 'nowrap'}}>
              CLOSING BALANCE
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td
              style={{
                padding: "8px",
                textAlign: "right",
                color: "#16A34A",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              {parseFloat(accounts[0]?.closing_balance || 0).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  )}
</div>

              </div>
       




          {savingsLoading && (
            <div className={classes.overlay}>
              <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
            </div>
          )}

        </div>
        )
}
        export default PrntCashbook;


       